(function () {
  'use strict';

  var API_BASE_URL = 'https://mojo-stamp-design-generator.vercel.app';
  var BRANDING_IRON_PRODUCT_URL = '/products/custom-branding-iron';
  var ICE_STAMP_PRODUCT_URL = '/products/custom-ice-stamp';

  var form = document.getElementById('design-generator-form');
  var promptInput = document.getElementById('design-prompt');
  var generateButton = document.getElementById('generate-button');
  var statusEl = document.getElementById('design-generator-status');
  var resultEl = document.getElementById('design-generator-result');
  var imageEl = document.getElementById('design-generator-image');
  var downloadButton = document.getElementById('download-button');
  var regenerateButton = document.getElementById('regenerate-button');
  var nextStepEl = document.getElementById('design-generator-next-step');

  var currentImage = null;

  function setStatus(message) {
    statusEl.textContent = message || '';
  }

  function setLoading(isLoading) {
    generateButton.disabled = isLoading;
    generateButton.textContent = isLoading ? 'Generating…' : 'Generate Design';
  }

  function showResult(image) {
    currentImage = image;
    imageEl.src = 'data:' + image.mimeType + ';base64,' + image.data;
    resultEl.hidden = false;
  }

  async function generate(prompt) {
    setLoading(true);
    setStatus('');
    resultEl.hidden = true;

    try {
      var response = await fetch(API_BASE_URL + '/api/generate', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: prompt }),
      });

      var payload = await response.json();

      if (!response.ok) {
        setStatus(payload.error || 'Something went wrong. Please try again.');
        return;
      }

      showResult({ mimeType: payload.mimeType, data: payload.data });

      if (typeof payload.remaining === 'number') {
        setStatus(
          payload.remaining > 0
            ? payload.remaining + ' design generation(s) left today.'
            : "That was your last free design for today — come back tomorrow for more."
        );
      }

      nextStepEl.innerHTML =
        'Like this design? Download it, then head to the ' +
        '<a href="' + BRANDING_IRON_PRODUCT_URL + '">branding iron</a> or ' +
        '<a href="' + ICE_STAMP_PRODUCT_URL + '">ice stamp</a> product page ' +
        'and upload it in the artwork field when you order.';
    } catch (err) {
      setStatus('Could not reach the design generator. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  function downloadCurrentImage() {
    if (!currentImage) return;
    var extension = currentImage.mimeType.split('/')[1] || 'png';
    var link = document.createElement('a');
    link.href = 'data:' + currentImage.mimeType + ';base64,' + currentImage.data;
    link.download = 'stamp-design.' + extension;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var prompt = promptInput.value.trim();
    if (!prompt) return;
    generate(prompt);
  });

  downloadButton.addEventListener('click', downloadCurrentImage);

  regenerateButton.addEventListener('click', function () {
    resultEl.hidden = true;
    setStatus('');
    promptInput.focus();
  });
})();
